import { EventRequestModel } from "@app/core";


export class EventRequestExportModel {
  Requestor_Name: string;
  Tenant_Name: string;
  Request_Status: string;
  Event_Type_Name: string;
  Primary_Point_Name: string;
  Request_Number: string;
  Event_Title: string;
  Start_Date: Date;
  End_Date: Date;
  Event_Start_Time: string;
  Event_End_Time: string;
  No_of_Public_Attendee: number;
  No_of_Private_Attendee: number;
  No_of_VIP_Executive: number;
  No_of_VIP_Diplomat: number;
  No_of_VIP_Minister: number;
  No_of_VIP_Head_Of_State: number;

  Arrive_Via_Visitorcards: string;
  Arrive_Via_Event_Invitation: string;
  Arrive_Via_Gate_Presence_Permit: string;
  Arrive_by_Bus: string;

  Permit_Holder_Name: string;
  Permit_Holder_Phone: string;
  Permit_Holder_Email: string;
  GPP_Justification: string;

  No_of_Busses: number;
  Bus_Capacity: number;
  Bus_Dimensions: string;
  Bus_Arrival_time: string;
  Bus_Departure_time: string;

  Primary_Point_Email: string;
  Primary_Point_Phone: string;
  Has_a_Catering: string;
  Has_a_advertising: string;
  Has_a_Furniture_Outside: string;
  Has_Heavy_Equipment: string;
  Has_a_Photography: string;
  Public_Parkings_List: string;
  Private_Parkings_List: string;
  No_of_Public_Parking_Spot: number;
  No_of_Private_Parking_Spot: number;



  Attendee_Arrival_time: string;
  Attendee_Departure_time: string;
  Catering_Company_Name: string;
  Catering_Focal_Point: string;
  Catering_Cell_Phone: string;
  Catering_Email: string;
  Catering_Setup_Date: Date;
  Catering_Setup_Time: string;
  Catering_Clearing_Date: Date;
  Catering_Clearing_Time: string;
  Catering_Movement_QSTP_Furniture: string;
  Catering_Storage_Area_Request: string;


  Ads_Installation_Date: Date;
  Ads_Installation_Time: string;
  Ads_Removal_Date: Date;
  Ads_Removal_Time: string;

  Heavy_Equipment_Arrival_Date: Date;
  Heavy_Equipment_Arrival_Time: string;
  Heavy_Equipment_Removing_Date: Date;
  Heavy_Equipment_Removing_Time: string;
  Heavy_Additional_Requirements: string;
  Heavy_Equipments_Delivery: string;

  Other_Requirements: string;


  Event_Locations: string;
  constructor(eventRequest: EventRequestModel) {
    this.Request_Number = eventRequest.requestNumber;
    this.Requestor_Name = eventRequest.requestorName;
    this.Request_Status = eventRequest.requestStatusName;
    this.Event_Title = eventRequest.eventTitle;
    this.Tenant_Name = eventRequest.tenantName;
    this.Event_Type_Name = eventRequest.eventTypeName;
    this.Start_Date = eventRequest.startDate;
    this.End_Date = eventRequest.endDate;
    this.Event_Start_Time = eventRequest.eventStartTime;
    this.Event_End_Time = eventRequest.eventEndTime;
    this.Primary_Point_Name = eventRequest.primaryPointName;
    this.Primary_Point_Email = eventRequest.primaryPointEmail
    this.Primary_Point_Phone = eventRequest.primaryPointPhone;
    this.No_of_Public_Attendee = eventRequest.attendeesNoOfPublic;
    this.No_of_Private_Attendee = eventRequest.attendeesNoOfPrivate;
    this.No_of_VIP_Executive = eventRequest.attendeesNoOfVIPExecutive;
    this.No_of_VIP_Diplomat = eventRequest.attendeesNoOfVIPDiplomat;
    this.No_of_VIP_Minister = eventRequest.attendeesVIPNoOfMinister;
    this.No_of_VIP_Head_Of_State = eventRequest.attendeesNoOfVIPHeadOfState;


    this.Arrive_Via_Visitorcards = (eventRequest.isViaVisitorcards) ? "Yes" : "No";
    this.Arrive_Via_Event_Invitation = (eventRequest.isViaEventInvitation) ? "Yes" : "No";
    this.Arrive_Via_Gate_Presence_Permit = (eventRequest.isViaGatePresencePermit) ? "Yes" : "No";
    this.Permit_Holder_Email = eventRequest.permitHolderEmail;
    this.Permit_Holder_Name = eventRequest.permitHolderName;
    this.Permit_Holder_Phone = eventRequest.permitHolderPhone;
    this.Attendee_Arrival_time = eventRequest.arrivaltime;
    this.Attendee_Departure_time = eventRequest.departuretime;
    this.GPP_Justification = eventRequest.gppJustification;


    this.Arrive_by_Bus = (eventRequest.isAttendeesWillArriveByBus) ? "Yes" : "No";

    this.No_of_Busses = eventRequest.noOfBusses;
    this.Bus_Capacity = eventRequest.busCapacity;
    this.Bus_Dimensions = eventRequest.busDimensions;
    this.Bus_Arrival_time = eventRequest.busArrivaltime;
    this.Bus_Departure_time = eventRequest.busDeparturetime;

    this.Has_a_Catering = (eventRequest.isCatered) ? "Yes" : "No";
    this.Catering_Company_Name = eventRequest.cateringCompanyName;
    this.Catering_Email = eventRequest.cateringEmail;
    this.Catering_Cell_Phone = eventRequest.cateringCellPhone;
    this.Catering_Focal_Point = eventRequest.cateringFocalPoint;
    this.Catering_Setup_Date = eventRequest.cateringSetupDate;
    this.Catering_Clearing_Date = eventRequest.cateringClearingDate;
    this.Catering_Setup_Time = eventRequest.cateringSetupTime;
    this.Catering_Clearing_Time = eventRequest.cateringClearingTime;
    this.Catering_Movement_QSTP_Furniture = (eventRequest.cateringMovementQSTPFurniture) ? "Yes" : "No";
    this.Catering_Storage_Area_Request = (eventRequest.cateringStorageAreaRequest) ? "Yes" : "No";
    

    this.Has_a_advertising = (eventRequest.isAdvertising) ? "Yes" : "No";
    this.Ads_Installation_Date = eventRequest.adsInstallationDate;
    this.Ads_Installation_Time = eventRequest.adsInstallationTime;
    this.Ads_Removal_Date = eventRequest.adsRemovalDate;
    this.Ads_Removal_Time = eventRequest.adsRemovalTime;

    this.Has_a_Furniture_Outside = (eventRequest.isFurnitureOutside) ? "Yes" : "No";
    this.Has_Heavy_Equipment = (eventRequest.isHeavyEquipment) ? "Yes" : "No";
    this.Heavy_Equipment_Arrival_Time = eventRequest.heavyEquipArrivalTime;
    this.Heavy_Equipment_Arrival_Date = eventRequest.heavyEquipArrivalDate;
    this.Heavy_Equipment_Removing_Date = eventRequest.heavyEquipRemovingDate;
    this.Heavy_Equipment_Removing_Time = eventRequest.heavyEquipRemovingTime
    this.Heavy_Equipments_Delivery = eventRequest.heavyEquipmentsDelivery;
    this.Heavy_Additional_Requirements = eventRequest.heavyAdditionalRequirements;
    this.Other_Requirements = eventRequest.otherRequirements;


    this.Has_a_Photography = (eventRequest.isPhotography) ? "Yes" : "No";
    this.No_of_Public_Parking_Spot = eventRequest.noOfPublicParkingSpot;

    this.Public_Parkings_List = eventRequest.publicParkingListView.join('/');
    this.No_of_Private_Parking_Spot = eventRequest.noOfVIPParkingSpot;

    this.Private_Parkings_List = eventRequest.privateParkingListView.join('/');


    this.Event_Locations = eventRequest.eventLocations.join('/');

    
  }

}



// WEBPACK FOOTER //
// ./src/app/core/models/event-request-export.ts